import { Button } from "@chakra-ui/react";
import React, { LegacyRef, ReactNode } from "react";
import { useSelector } from "react-redux";
import { useLightMode } from "src/common/hooks/lightMode";

interface PrimaryColorButtonI {
  children: ReactNode;
  colorModeOverride?: "light" | "dark";
  isOutlineVariant?: boolean;
  loading?: boolean;
  [label: string]: unknown;
}

const PrimaryColorButton = React.forwardRef(
  (props: PrimaryColorButtonI, ref: LegacyRef<HTMLButtonElement>) => {
    const {
      children,
      colorModeOverride,
      isOutlineVariant = false,
      loading,
      ...rest
    } = props;
    const { lightMode } = useLightMode(colorModeOverride);
    const primaryColor = useSelector((state: any) => {
      return lightMode
        ? state?.application?.colors?.light?.primary
        : state?.application?.colors?.dark?.primary;
    });

    const buttonStyles = isOutlineVariant
      ? {
          // Outline variant styles
          bg: "transparent",
          color: primaryColor || "primary",
          border: "1px solid",
          borderColor: primaryColor || "primary",
          lineHeight: 1.15,
          _hover: {
            bg: `rgb(from ${primaryColor || "primary"} r g b / 10%)`,
          },
          _active: {
            bg: `rgb(from ${primaryColor || "primary"} r g b / 15%)`,
          },
          // Preserve loading state styles
          _loading: {
            bg: "transparent",
            color: primaryColor || "primary",
            borderColor: primaryColor || "primary",
            opacity: 0.6,
          },
        }
      : {
          // Solid variant styles
          bg: primaryColor || "primary",
          color: "white", //lightMode ? "white" : "#2D3840",
          lineHeight: 1.15,
          _hover: {
            bg: `hsl(from ${primaryColor || "primary"} h s calc(l - 8))`,
          },
          _active: {
            bg: `hsl(from ${primaryColor || "primary"} h s calc(l - 12))`,
          },
          // Preserve loading state styles
          _loading: {
            bg: primaryColor || "primary",
            color: lightMode ? "white" : "#2D3840",
            opacity: 0.6,
          },
        };

    return (
      <Button {...buttonStyles} isLoading={loading} {...rest} ref={ref}>
        {children}
      </Button>
    );
  },
);

export default PrimaryColorButton;
